const apiUrl = process.env.REACT_APP_API_URL;

const putMaintenanceActivity = (token, data, cb) => {
    fetch(`${apiUrl}/maintenanceactivities`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default putMaintenanceActivity;
